import { injectedAccessLevelSelector } from '../utils/accessLevelSelectorInjection'
import { useSelector } from 'react-redux'
import { RootState } from '../../../reducers'
import { AccessLevel } from '../types'
import { accessLevelSelector } from '../selectors'

export function useAccessLevel(): AccessLevel {
  const storeAccessLevel = useSelector<RootState, AccessLevel>(accessLevelSelector)
  const injectedAccessLevel = injectedAccessLevelSelector()

  // Hack for testing, because useAccessLevel selector is a splendid mess,
  // and I would rather kill myself than dynamically mock the result via
  // store mock in Storybook and Cypress component tests :)
  if (injectedAccessLevel) {
    return injectedAccessLevel
  }

  return storeAccessLevel
}
